// extracted by mini-css-extract-plugin
export default {"container":"ChatPage_container__6eI6W","chat":"ChatPage_chat__D6KW4","chatContainer":"ChatPage_chatContainer__1fgqy","content":"ChatPage_content__+YosN"};